<div class="min-h-screen mx-auto px-4 flex flex-col"
     *ngIf="config"
     [class.max-w-5xl]="config.screenRatio < 1"
     [class.max-w-xl]="config.screenRatio >= 1"
>

  <div class="rounded-lg shadow w-2/3 mx-auto">

    <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t border-neutral-600">
      <h3 class="text-xl font-semibold text-neutral-50">
        Web Booth Configuration
      </h3>
    </div>

    <div class="flex flex-col relative aspect-square">
      <video #videoContainer
             [class.-rotate-90]="rotate == 270"
             [class.rotate-90]="rotate == 90"
             [class.rotate-180]="rotate == 180"
             class="absolute w-full h-auto border-2 border-neutral-500 mb-6 [transform:rotateY(180deg)] aspect-square"></video>
      <div class="w-full aspect-square absolute z-40 items-center justify-center flex text-2xl" *ngIf="loading">Camera Loading ...</div>
    </div>

    <div class="p-4 md:p-5 space-y-4 text-neutral-400 text-xs md:test-base lg:text-lg flex flex-col">

      <form [formGroup]="form" (submit)="onSubmit()" class="flex flex-col">
        <select formControlName="device" id="device-change" (change)="switchCamera($event)"
                class="border text-sm rounded-lg block w-full p-2.5 bg-neutral-700 border-neutral-600 placeholder-neutral-400 text-white focus:ring-blue-500 focus:border-blue-500">
          <option *ngFor="let device of devices; index as i" [value]="device.deviceId">{{ device.label || 'camera ' + i }}</option>
        </select>

        <label class="relative inline-flex items-center cursor-pointer my-6">
          <input type="checkbox" value="" class="sr-only peer" formControlName="forceBoothMode" checked>
          <span class="w-11 h-6 bg-neutral-800 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-neutral-100 after:border-neutral-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-700"></span>
          <span class="ml-3 text-sm font-medium text-neutral-300">Force Booth Mode</span>
        </label>

        <select formControlName="rotation"
                (change)="setRotation($event)"
                class="border text-sm rounded-lg block w-full p-2.5 mb-3 bg-neutral-700 border-neutral-600 placeholder-neutral-400 text-white focus:ring-blue-500 focus:border-blue-500">
          <option value="0">0 (default)</option>
          <option value="90">90</option>
          <option value="180">180</option>
          <option value="270">270</option>
        </select>

        <button type="submit" class="w-full px-5 py-3 my-2 text-2xl font-bold uppercase text-center text-neutral-200 bg-blue-700 rounded-lg hover:bg-blue-800 disabled:bg-neutral-700 disabled:text-neutral-500">Save</button>
      </form>
    </div>
  </div>
</div>
